module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/5-464eb2ab226080eacf230e385890597c.png";